import { ODataSoftwareLicenceSet } from '../../services/software-licences/software-licence.model';
import { SoftwareLicenceState } from './software-licences-collection.state';

export function oDataToPlain(odata: ODataSoftwareLicenceSet[]): SoftwareLicenceState[] {
    return odata.map((entry) => {
        const plain: SoftwareLicenceState = {
            materialNumber: entry.Material,
            serialNumber: entry.SerialNo,
            description: entry.Description,
            startDate: entry.StartDate ?? '',
            endDate: entry.EndDate ?? '',
            status: entry.Status,
        };

        return plain;
    });
}
